import { render, staticRenderFns } from "./Agrupamento.vue?vue&type=template&id=9e895812"
import script from "./Agrupamento.vue?vue&type=script&lang=js"
export * from "./Agrupamento.vue?vue&type=script&lang=js"
import style0 from "./Agrupamento.vue?vue&type=style&index=0&id=9e895812&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports